module.exports = __webpack_public_path__ + "static/media/img_profile_2.76f4bd58.png";